<template>
  <div id="app">
    <div class="new-im-message" :class="{show: messageAnimate}" v-show="showNewMessage">
      <div class="follow" v-if="newMessage.type === 'follow'">{{ $t('whoFollowedYou', [newMessage.target]) }}</div>
      <div class="message" v-else>{{ $t('whoSendYouMessage', [userInfo.nick]) }}</div>
    </div>
    <router-view v-if="!sysMaintenanceFlag"/>
    <sys-maintenance v-model="sysMaintenanceFlag" v-if="sysMaintenanceFlag"/>

    <img v-show="loadingShowFlag" class="loading" :src="require('@assets/imgs/public/loading.gif')"/>
    <uploadTips />
  </div>
</template>

<script>
import { info } from '@api/userDetail';
import { deviceAccountLoginRegister } from '@api/loginRegister';
import { getPublicConfig } from '@api/public';
import { getBrowserLang } from '@utils';
import SysMaintenance from '@components/sysMaintenance';
import webSocket from '@/mixins/webSocket';
import uploadTips from '@components/uploadTips/index.vue';

export default {
  name: 'App',
  mixins: [webSocket],
  components: {
    uploadTips,
    SysMaintenance
  },
  data () {
    return {
      sysMaintenanceFlag: false,
      showNewMessage: false,
      messageAnimate: false,
      wsUrl: ''
    };
  },
  computed: {
    ...mapState('publicStore', ['loadingShowFlag', 'sysMaintenanceInfo', 'keyboardHeight', 'isApp']),
    ...mapState('message', ['newMessage']),
    ...mapState('user', ['userInfo']),
    ...mapGetters('message', ['getTargetUserInfo']),
    currentAccid () {
      return this.$route.query.accid;
    },
    handleWsUrl () {
      const deviceNo = localStorage.getItem('deviceNo') || new Date().getTime();
      let url = this.wsUrl + `?type=1&from=2&uid=${deviceNo}`;
      if (this.token) {
        url = this.wsUrl + `?type=2&from=2&uid=${this.userInfo.uid}`;
      }
      return url;
    },
    userInfo () {
      if (this.newMessage.type === 'message') {
        return this.getTargetUserInfo(this.newMessage.target);
      }

      return {};
    }
  },
  watch: {
    '$route.query': {
      handler (val) {
        if (val.isWebClip === '1') {
          this.setIsWebClip(true);
        }
        if (val.isApp === '1' || val.isWebClip === '1') {
          if (val.inviteCode) {
            localStorage.setItem('inviteCode', val.inviteCode);
          }
        }
      },
      immediate: true
    },
    '$route.path' (val) {
      if (val !== '/ai') {
        this.setIsShowUploadTips(false);
      }
    },
    showNewMessage (val) {
      if (val) {
        setTimeout(() => {
          this.messageAnimate = true;

          setTimeout(() => {
            this.messageAnimate = false;

            setTimeout(() => {
              this.showNewMessage = false;
            }, 350);
          }, 3000);
        }, 50);
      }
    },
    newMessage (val) {
      if (this.showNewMessage === false && val.accid !== this.currentAccid) {
        this.showNewMessage = true;
      }
    },
    token: {
      handler (val) {
        if (val) {
          this.getUserInfo();
        }
      },
      immediate: true
    },
    sysMaintenanceInfo: {
      handler (val) {
        this.sysMaintenanceFlag = !!val.start;
      },
      immediate: true
    },
    handleWsUrl: {
      handler (val) {
        // this.initWs(val);
      }
    },
    keyboardHeight (val) {
      // 处理在app里键盘会挡住评论内容的问题
      if (val && this.isApp && this.$route.path === '/home') {
        document.getElementById('app').style.bottom = this.keyboardHeight + 'px';
        document.getElementById('publicFooter').style.bottom = this.keyboardHeight + 'px';
      } else {
        document.getElementById('app').style.bottom = 0;
        document.getElementById('publicFooter').style.bottom = 0;
      }
    }
  },
  beforeDestroy () {
    this.destroyWs();
  },
  created () {
    console.log(this.setIsShowLimitNum);
    document.addEventListener('UniAppJSBridgeReady', () => {
      // eslint-disable-next-line no-undef
      uni.webView.getEnv((res) => {
        this.setIsApp(!!res.plus);
        console.log('当前环境：' + JSON.stringify(res));
      });
      // uni.webView.navigateTo(...)
    });

    window.setDataToWebView = (data) => {
      if (data.action === 'setKeyboardHeight') {
        this.setKeyboardHeight(data.value);
      }
    };

    this.getLanguages();
    this.getPublicConfig();
    this.getNoticeList();
    if (!this.token) {
      this.fetchDeviceAccountLoginRegister();
    }
    // 清楚错误的lang缓存
    const lang = localStorage.getItem('lang');
    if (lang && !['TC', 'VNM', 'USA'].includes(lang)) {
      localStorage.removeItem('lang');
      const browserLang = getBrowserLang();
      this.$i18n.locale = browserLang;
      localStorage.setItem('lang', browserLang);
    }
    // 精致在safari浏览器下缩放
    let lastTouchEnd = 0;
    document.addEventListener('touchstart', () => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });

    document.addEventListener('touchend', () => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);

    document.addEventListener('gesturestart', () => {
      event.preventDefault();
    });

    document.addEventListener('dblclick', () => {
      event.preventDefault();
    });
  },
  mounted () {
    document.getElementById('favicon').setAttribute('href', this.siteConfig.favicon);
    document.title = this.siteConfig.title;
  },
  methods: {
    ...mapMutations('user', ['setUserInfo', 'setToken']),
    ...mapMutations('publicStore', ['setDownloadPage', 'setPublicConfig', 'setIsApp', 'setIsWebClip', 'setKeyboardHeight', 'setIsShowUploadTips']),
    ...mapActions('publicStore', ['getLanguages', 'getNoticeList']),
    getUserInfo () {
      info().then(res => {
        if (res.result === 200000) {
          this.setUserInfo(res.data.info);
        }
      });
    },
    getPublicConfig () {
      getPublicConfig().then(res => {
        if (res.result === 200000) {
          const list = res.data.list;
          this.setPublicConfig(list);
          this.setDownloadPage(list.download_url.url);
          this.wsUrl = list.ws_url;
        }
      });
    },
    onclose () {
      this.ws = null;
      if (!this.oncloseTimer) {
        this.oncloseTimer = setInterval(() => {
          if (!this.ws) {
            this.initWs(this.handleWsUrl);
          } else {
            clearInterval(this.oncloseTimer);
            this.oncloseTimer = null;
          }
        }, 5000);
      }
    },
    destroyWs () {
      this.ws.close();
      this.ws = null;
      clearInterval(this.oncloseTimer);
      clearInterval(this.heartBeatTimer);
      this.oncloseTimer = null;
      this.heartBeatTimer = null;
    },
    //  游客登录/注册
    fetchDeviceAccountLoginRegister () {
      deviceAccountLoginRegister().then(res => {
        if (res.result === 200000) {
          this.setToken(res.data.info.token);
          this.setUserInfo(res.data.info);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#app {
  position: relative;
  width: 100%;
  height: 100%;

  .loading {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000000000;
    width: 40px;
    height: 40px;
  }
}

.new-im-message {
  z-index: 9999;
  position: absolute;
  min-width: 168px;
  height: 34px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 19px;
  left: 50%;
  top: 85px;
  white-space: nowrap;
  transform: translate(-50%, -150%);
  transition: all 0.3s ease-out;
  font-family: 'PingFang SC';
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  color: #161616;
  opacity: 0;

  &.show {
    opacity: 1;
    transform: translate(-50%, 0);
  }

}
</style>
